export default __webpack_public_path__ + "static/footer_logo_ffxiv_jp-1364dfe2-66a8cdb78ea013facc41313038f83a9c.png";